@if (layout.hasLayout) {
  <nz-layout>
    @if (layout.hasMenu) {
      <nz-sider [nzWidth]="62" nzTheme="dark" class="sidenav">
        <app-menu />
      </nz-sider>
    }
    <nz-layout>
      @if (layout.hasStatusBar) {
        <app-status-bar [autoHide]="layout.autoHideStatusBar" />
      }
      <nz-content [id]="layout.hasLayoutPadding ? 'content' : 'content-no-padding'">
        <router-outlet />
      </nz-content>
    </nz-layout>
  </nz-layout>
} @else {
  <router-outlet />
}
